import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const SecondaryMarketQuotesWorkspaceLazy = lazyWithRetry(() => import('./SecondaryMarketQuotesWorkspace'));
export function SecondaryMarketQuotesWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <SecondaryMarketQuotesWorkspaceLazy />
    </Suspense>
  );
}
